import { config } from "../config/config";
import { getAuthToken } from "./tokenService.service";

export const topCustomerService = {
  topCustomers: async (end_date: string) => {
    const token = getAuthToken();

    const response = await fetch(
      `${config.baseURL}/topcustomer/customer-sla-summary`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ end_date }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch top customers");
    }

    const json = await response.json();
    return json;
  },
};
